import React from 'react';

import { toAbsoluteUrl } from '_metronic/_helpers';
import ModalDialog from 'app/components/flat/ui/ModalDialog';

import * as S from '../modalStyles';

const THANKS_ILLUSTRATION = '/media/onboarding/welcome.svg';
const TITLE_ID = 'oab-capture-thanks-title';

type OabThanksModalProps = {
  onClose: () => void;
};

const OabThanksModal = ({
  onClose,
}: OabThanksModalProps): React.ReactElement => {
  return (
    // Foco preso no card, foco inicial, devolução do foco ao fechar, lock de
    // scroll e Esc vêm do Dialog; só o clique no backdrop segue ignorado, para
    // não transformar clique acidental em dispensa.
    <ModalDialog
      open
      width="500px"
      overflow="hidden"
      aria-labelledby={TITLE_ID}
      onClose={(_event: unknown, reason: string) =>
        reason === 'escapeKeyDown' && onClose()
      }
    >
      <S.Card>
        <S.Illustration src={toAbsoluteUrl(THANKS_ILLUSTRATION)} alt="" />
        <S.CloseButton type="button" aria-label="Fechar" onClick={onClose}>
          ×
        </S.CloseButton>

        <S.Body>
          <S.Title id={TITLE_ID}>
            Obrigado! Não vamos mais perguntar isso.
          </S.Title>
          <S.Description>
            Caso ainda queira cadastrar uma OAB, você pode fazer isso nas
            configurações da sua conta.
          </S.Description>

          <S.Actions>
            <S.ConfirmAnswer type="button" onClick={onClose}>
              Entendi
            </S.ConfirmAnswer>
          </S.Actions>
        </S.Body>
      </S.Card>
    </ModalDialog>
  );
};

export default OabThanksModal;
